import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBlogReport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 13.25C7.58579 13.25 7.25 13.5858 7.25 14C7.25 14.4142 7.58579 14.75 8 14.75H16C16.4142 14.75 16.75 14.4142 16.75 14C16.75 13.5858 16.4142 13.25 16 13.25H8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H16C16.4142 16.25 16.75 16.5858 16.75 17C16.75 17.4142 16.4142 17.75 16 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9 6.25C8.0335 6.25 7.25 7.0335 7.25 8V10C7.25 10.9665 8.0335 11.75 9 11.75H11C11.9665 11.75 12.75 10.9665 12.75 10V8C12.75 7.0335 11.9665 6.25 11 6.25H9ZM8.75 8C8.75 7.86193 8.86193 7.75 9 7.75H11C11.1381 7.75 11.25 7.86193 11.25 8V10C11.25 10.1381 11.1381 10.25 11 10.25H9C8.86193 10.25 8.75 10.1381 8.75 10V8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.28888 2.25C4.70504 2.25 3.25 3.38965 3.25 5.00324V18.9968C3.25 20.6104 4.70504 21.75 6.28888 21.75H17.7111C19.2889 21.75 20.7339 20.6078 20.75 19.0043V5.00324C20.75 3.38965 19.295 2.25 17.7111 2.25H6.28888ZM4.75 5.00324C4.75 4.39965 5.3394 3.75 6.28888 3.75H17.7111C18.6606 3.75 19.25 4.39965 19.25 5.00324V18.9925C19.2418 19.6051 18.6428 20.25 17.7111 20.25H6.28888C5.3394 20.25 4.75 19.6003 4.75 18.9968V5.00324Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconBlogReport as ReactComponent };
